import styled from 'styled-components';

export const TableRow = styled.tr`
  td {
    text-align: center;
  }
`;
